import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sercret-flyhns',
  templateUrl: './sercret-flyhns.component.html',
  styleUrls: ['./sercret-flyhns.component.css']
})
export class SercretFlyhnsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
